{
"actions.addLocalFile": "ローカルにファイルを追加",
"actions.deleteAndPush": "既存ファイルを削除",
"actions.editAndPush": "既存ファイルを編集",
"actions.fetchRemote": "リモート一覧をpull",
"actions.listAdapters": "アダプタ一覧",
"actions.listFilesRaw": "listFilesRaw() を実行",
"actions.localChanges": "ローカルの変更一覧を表示",
"actions.pushLocal": "ローカルのチェンジセットを push",
"actions.remoteChanges": "リモートで新しいファイル一覧 (チェンジセット)",
"actions.rename": "既存ファイルを名前変更",
"actions.resolveConflict": "競合を解消済にする",
"actions.revertChange": "変更を元に戻す",
"actions.showSnapshot": "スナップショット（ローカル）一覧表示",
"actions.showFileContent": "ファイル内容を表示",
"actions.showConflictContent": "競合内容を表示",
"actions.title": "操作",
"branch.flag.default": "既定",
"branch.flag.protected": "保護済み",
"confirm.delete": "本当に削除しますか: {path}",
"createBranch.label": "branch作成",
"error.addLocalFile.failed": "[addLocalFileBtn]addLocalFile 失敗: {err}",
"error.connect.exception": "[connectBtn]接続処理で例外: {err}",
"error.connectIndexedDb.exception": "[connectIndexedDbBtn]IndexedDatabaseStorage 接続で例外: {err}",
"error.connectInMemory.exception": "[connectInMemoryBtn]InMemoryStorage 接続で例外: {err}",
"error.connectOpfs.exception": "[connectOpfsBtn]OpfsStorage 接続で例外: {err}",
"error.createBranch.failed": "[createBranch]失敗: {err}",
"error.createBranch.notImplemented": "[createBranch]VirtualFS に createBranch() が実装されていません",
"error.createBranch.vfsNotInit": "[createBranch]先に VirtualFS を初期化してください",
"error.default": "{err}",
"error.deleteAndPush.failed": "[deleteAndPushBtn]deleteAndPush 失敗: {err}",
"error.deleteAndPush.noAdapter": "[deleteAndPushBtn]先にアダプタを接続してください",
"error.deleteAndPush.vfsNotInit": "[deleteAndPushBtn]先に VirtualFS を初期化してください",
"error.deleteIndexedDb.failed": "[deleteIndexedDbBtn]削除に失敗しました: {err}",
"error.deleteIndexedDb.noCtor": "[deleteIndexedDbBtn]IndexedDatabaseStorage が見つかりません",
"error.deleteIndexedDb.noMethod": "[deleteIndexedDbBtn]IndexedDatabaseStorage に削除メソッドが実装されていません",
"error.deleteIndexedDb.noSelection": "[deleteIndexedDbBtn]削除対象の DB が選択されていません",
"error.deleteInMemory.failed": "[deleteInMemoryBtn]削除に失敗しました: {err}",
"error.deleteInMemory.noCtor": "[deleteInMemoryBtn]InMemoryStorage が見つかりません",
"error.deleteInMemory.noMethod": "[deleteInMemoryBtn]InMemoryStorage に削除メソッドが実装されていません",
"error.deleteInMemory.noSelection": "[deleteInMemoryBtn]削除対象のルートが選択されていません",
"error.deleteOpfs.failed": "[deleteOpfsBtn]削除に失敗しました: {err}",
"error.deleteOpfs.noCtor": "[deleteOpfsBtn]OpfsStorage が見つかりません",
"error.deleteOpfs.noMethod": "[deleteOpfsBtn]OpfsStorage に削除メソッドが実装されていません",
"error.deleteOpfs.noSelection": "[deleteOpfsBtn]削除対象のルートが選択されていません",
"error.editAndPush.failed": "[editAndPushBtn]editAndPush 失敗: {err}",
"error.editAndPush.noAdapter": "[editAndPushBtn]先にアダプタを接続してください",
"error.editAndPush.vfsNotInit": "[editAndPushBtn]先に VirtualFS を初期化してください",
"error.fetchRemote.failed": "[fetchRemoteBtn]pull 失敗: {err}",
"error.fetchRemote.indexException": "[fetchRemoteBtn]pull 後のインデックス表示で例外: {err}",
"error.fetchRemote.vfsNotInit": "[fetchRemoteBtn]先に VirtualFS を初期化してください",

"error.indexeddb.connectFailed": "[indexedDbRoots]接続失敗: {err}",
"error.indexeddb.failed": "[indexedDbRoots]取得失敗: {err}",
"error.indexeddb.missing": "[indexedDbRoots]バンドルに IndexedDatabaseStorage が含まれていません",
"error.indexeddb.notImplemented": "[indexedDbRoots]IndexedDatabaseStorage に availableRoots() が実装されていません",
"error.inmemory.connectFailed": "[inMemoryRoots]接続失敗: {err}",
"error.inmemory.failed": "[inMemoryRoots]取得失敗: {err}",
"error.invalidUrl": "[connectBtn]無効な URL です。例: https://github.com/owner/repo",
"error.listBranches.failed": "[listBranches]失敗: {err}",
"error.listBranches.notImplemented": "[listBranches]VirtualFS に listBranches() が実装されていません",
"error.listBranches.vfsNotInit": "[listBranches]先に VirtualFS を初期化してください",
"error.listCommits.failed": "[listCommits]失敗: {err}",
"error.listCommits.notImplemented": "[listCommits]VirtualFS に listCommits() が実装されていません",
"error.listCommits.vfsNotInit": "[listCommits]先に VirtualFS を初期化してください",
"error.listFilesRaw.failed": "[listFilesRaw]listFilesRaw 実行で例外: {err}",
"error.listFilesRaw.notImplemented": "[listFilesRaw]listFilesRaw() が VirtualFS/Backend に実装されていません",
"error.listFilesRaw.vfsNotInit": "[listFilesRaw]先に VirtualFS を初期化してください",
"error.localChanges.failed": "[localChangesBtn]localChanges 失敗: {err}",
"error.localChanges.vfsNotInit": "[localChangesBtn]先に VirtualFS を初期化してください",
"error.nextCommitsPage.failed": "[nextCommitsPage]失敗: {err}",
"error.nextCommitsPage.noNext": "[nextCommitsPage]次ページは存在しません",
"error.nextCommitsPage.vfsNotInit": "[nextCommitsPage]先に VirtualFS を初期化してください",
"error.opfs.connectFailed": "[opfsRoots]接続失敗: {err}",
"error.opfs.failed": "[opfsRoots]取得失敗: {err}",
"error.opfs.missing": "[opfsRoots]バンドルに OpfsStorage が含まれていません",
"error.pushLocal.failed": "[pushLocalBtn]pushLocal 失敗: {err}",
"error.pushLocal.noAdapter": "[pushLocalBtn]先にアダプタを接続してください",
"error.pushLocal.vfsNotInit": "[pushLocalBtn]先に VirtualFS を初期化してください",
"error.remoteChanges.failed": "[remoteChangesBtn]remoteChanges 失敗: {err}",
"error.remoteChanges.notImplemented": "[remoteChangesBtn] VirtualFS に getRemoteDiffs() が存在しません",
"error.remoteChanges.vfsNotInit": "[remoteChangesBtn]先に VirtualFS を初期化してください",
"error.rename.failed": "[renameBtn]renameBtn 失敗: {err}",
"error.rename.noAdapter": "[renameBtn]先にアダプタを接続してください",
"error.rename.vfsNotInit": "[renameBtn]先に VirtualFS を初期化してください",
"error.resolveConflict.failed": "[resolveConflictBtn]resolveConflict 失敗: {err}",
"error.resolveConflict.notImplemented": "[resolveConflictBtn]VirtualFS に resolveConflict() が実装されていません",
"error.revertChange.backendException": "[revertChangeBtn]backend.deleteBlob で例外: {err}",
"error.revertChange.backendNoDelete": "[revertChangeBtn]バックエンドが deleteBlob をサポートしていません",
"error.revertChange.failed": "[revertChangeBtn]変更の復元に失敗しました: {err}",
"error.revertChange.readFailed": "[revertChangeBtn]ファイル読み取りで例外: {err}",
"error.revertChange.vfsReinitFailed": "[revertChangeBtn]VirtualFS の再初期化で例外: {err}",
"error.showSnapshot.failed": "[showSnapshotBtn]スナップショット一覧取得で例外: {err}",
"error.showSnapshot.unexpected": "[showSnapshotBtn]一覧表示処理で例外: {err}",
"error.showSnapshot.vfsNotInit": "[showSnapshotBtn]先に VirtualFS を初期化してください",
"error.showFileContent.failed": "[showFileContentBtn]表示処理で例外: {err}",
"error.showFileContent.readFailed": "[showFileContentBtn]読み取りに失敗しました: {path} {err}",
"error.showFileContent.vfsNotInit": "[showFileContentBtn]先に VirtualFS を初期化してください",
"error.showConflictContent.failed": "[showConflictContentBtn]表示処理で例外: {err}",
"error.showConflictContent.notImplemented": "[showConflictContentBtn]VirtualFS に readConflict() が実装されていません",
"error.showConflictContent.readFailed": "[showConflictContentBtn]読み取りに失敗しました: {path} {err}",
"error.showConflictContent.vfsNotInit": "[showConflictContentBtn]先に VirtualFS を初期化してください",
"error.switchBranch.exception": "[switchBranch]例外: {err}",
"error.switchBranch.pullFailed": "[switchBranch]pull によるブランチ切替で失敗しました: {err}",
"error.switchBranch.vfsNotConnected": "[switchBranch]VirtualFS が未接続です",

"error.vfs.cleanup": "[{prefix}]既存 VirtualFS のクリーンアップで例外: {err}",
"error.vfs.connectFailed": "[{prefix}]接続失敗: {err}",
"error.vfs.initException": "[{prefix}]VirtualFS.init() で例外: {err}",
"error.vfs.missing": "[{prefix}]{displayName}/VirtualFS が見つかりません",
"error.vfs.notConnected": "[connectBtn]VirtualFS が接続されていません。adapter 情報を登録できません",
"error.vfs.setAdapter": "[connectBtn]VirtualFS に adapter 情報を設定できませんでした: {err}",
"error.vfs.uninitialized": "[{prefix}]VirtualFS は接続されていません",
"form.branch": "Branch:",
"form.connect": "接続設定の更新",
"form.platform": "Platform:",
"form.repo": "Repository URL:",
"form.token": "Token:",
"listBranches.label": "ブランチを取得",
"listCommits.label": "コミットを取得",
"log.addLocalFile.added": "[addLocalFileBtn]ローカルにファイルを追加しました: {path}, {content}",
"log.connect.input": "[connectBtn]入力: repo={repo} token={token}",
"log.connect.start": "[connectBtn]接続を試みます...",
"log.createBranch.ref": "[createBranch]ref: {ref}",
"log.createBranch.sha": "[createBranch]sha: {sha}",
"log.createBranch.start": "[createBranch]新しいブランチを作成します...",
"log.createBranch.success": "[createBranch]作成成功: {name}",
"log.deleteAndPush.deleted": "[deleteAndPushBtn]ローカルで削除しました: {path}",
"log.deleteAndPush.start": "[deleteAndPushBtn]既存ファイルの削除を開始します...",
"log.deleteIndexedDb.done": "[deleteIndexedDbBtn]IndexedDB {val} を削除しました",
"log.deleteIndexedDb.start": "[deleteIndexedDbBtn]選択された IndexedDB を削除します...",
"log.deleteInMemory.done": "[deleteInMemoryBtn]InMemory ルート {val} を削除しました",
"log.deleteInMemory.start": "[deleteInMemoryBtn]選択された InMemory のルートを削除します...",
"log.deleteOpfs.done": "[deleteOpfsBtn]OPFS ルート {val} を削除しました",
"log.deleteOpfs.start": "[deleteOpfsBtn]選択された OPFS のルートを削除します...",
"log.editAndPush.edited": "[editAndPushBtn]ローカル編集しました: {path}",
"log.editAndPush.start": "[editAndPushBtn]既存ファイルの編集 を開始します...",
"log.fetchRemote.addedFiles": "[fetchRemoteBtn]pull で新規に登録されたファイル: {list}",
"log.fetchRemote.conflictBaseSha": "[fetchRemoteBtn]  baseSha: {sha}",
"log.fetchRemote.conflictEnd": "[fetchRemoteBtn]--- 以上 ---",
"log.fetchRemote.conflictHeader": "[fetchRemoteBtn]--- コンフリクト詳細 ---",
"log.fetchRemote.conflictPath": "[fetchRemoteBtn]path: {path}",
"log.fetchRemote.conflictRemoteSha": "[fetchRemoteBtn]  remoteSha: {sha}",
"log.fetchRemote.conflictShowException": "[fetchRemoteBtn]  コンフリクト表示で例外: {err}",
"log.fetchRemote.conflictWorkspaceSha": "[fetchRemoteBtn]  workspaceSha: {sha}",
"log.fetchRemote.fetchContentCount": "[fetchRemoteBtn]fetchContent 対象ファイル数: {count}",
"log.fetchRemote.indexCount": "[fetchRemoteBtn]インデックス内ファイル数: {count}",
"log.fetchRemote.indexTop": "[fetchRemoteBtn]インデックス先頭ファイル: {list}",
"log.fetchRemote.localReadError": "[fetchRemoteBtn]  local read error: {err}",
"log.fetchRemote.localSnippet": "[fetchRemoteBtn]  local (workspace) snippet: {snippet}",
"log.fetchRemote.moreFiles": "[fetchRemoteBtn]... 他 {n} 件",
"log.fetchRemote.pullDone": "[fetchRemoteBtn]pull 完了。コンフリクト数: {count}",
"log.fetchRemote.reconciled": "[fetchRemoteBtn]ローカル一致で再計算されたファイル: {list}",
"log.fetchRemote.remoteCount": "[fetchRemoteBtn]リモートファイル数: {count}",
"log.fetchRemote.remoteReadError": "[fetchRemoteBtn]  remote read error: {err}",
"log.fetchRemote.remoteSnippet": "[fetchRemoteBtn]  remote snippet: {snippet}",
"log.fetchRemote.remoteTop": "[fetchRemoteBtn]リモート先頭ファイル: {list}",
"log.fetchRemote.resolvedConflicts": "[fetchRemoteBtn]解決済コンフリクト数: {count}",
"log.fetchRemote.start": "[fetchRemoteBtn]リモートスナップショットを取得します...",
"log.github.adapterCreated": "GitHubAdapter 作成",
"log.github.registered": "GitHub 接続情報を VirtualFS に登録しました (branch={branch})",
"log.gitlab.adapterCreated": "GitLabAdapter 作成",
"log.gitlab.registered": "GitLab 接続情報を VirtualFS に登録しました (branch={branch})",
"log.indexeddb.availableRoots": "[indexedDbRoots]availableRoots: {roots}",
"log.inmemory.availableRoots": "[inMemoryRoots]availableRoots: {roots}",
"log.inmemory.availableRootsStart": "[inMemoryRoots]availableRoots を呼び出します...",
"log.listBranches.count": "[listBranches]取得ブランチ数: {count}",
"log.listBranches.paging": "[listBranches]nextPage: {next} lastPage: {last}",
"log.listBranches.start": "[listBranches]ブランチ一覧を取得します...",
"log.listCommits.count": "[listCommits]取得コミット数: {count}",
"log.listCommits.more": "[listCommits]... 他 {n} 件",
"log.listCommits.paging": "[listCommits]nextPage: {next} lastPage: {last}",
"log.listCommits.start": "[listCommits]コミット一覧を取得します...",
"log.listFilesRaw.backendCount": "[listFilesRaw]取得件数 (backend): {count}",
"log.listFilesRaw.count": "[listFilesRaw]取得件数: {count}",
"log.listFilesRaw.start": "[listFilesRaw]listFilesRaw() を実行します（引数省略）",
"log.localChanges.list": "[localChangesBtn]ローカル変更一覧:\n{json}",
"log.nextCommitsPage.count": "[nextCommitsPage]取得コミット数: {count}",
"log.nextCommitsPage.current": "[nextCommitsPage]currentPage: {current} lastPage: {last}",
"log.nextCommitsPage.start": "[nextCommitsPage]次ページのコミットを取得します...",
"log.opfs.availableRoots": "[opfsRoots]availableRoots: {roots}",
"log.pushLocal.noChanges": "[pushLocalBtn]Push する変更がありません",
"log.pushLocal.start": "[pushLocalBtn]ローカルのチェンジセットをリモートに push します...",
"log.pushLocal.success": "[pushLocalBtn]push 成功: {json}",
"log.remoteChanges.count": "[remoteChangesBtn]リモート差分ファイル数: {count}",
"log.remoteChanges.start": "[remoteChangesBtn]リモートとローカルの差分を取得します...",
"log.rename.renamed": "[renameBtn]ローカルでリネームしました: {from} -> {to}",
"log.rename.start": "[renameBtn]既存ファイルの名前変更を開始します...",
"log.resolveConflict.notFoundOrFailed": "[resolveConflictBtn]競合ファイルが見つからないか削除に失敗しました: {path}",
"log.resolveConflict.succeeded": "[resolveConflictBtn]競合を解消しました: {path}",
"log.revertChange.deleting": "[revertChangeBtn]ワークスペースの変更を削除します: {path}",
"log.revertChange.done": "[revertChangeBtn]操作完了: {path} -> {snippet}",
"log.showSnapshot.count": "[showSnapshotBtn]ファイル数: {count}",
"log.showSnapshot.fileEntry": "[showSnapshotBtn]- {path}",
"log.showSnapshot.noFiles": "[showSnapshotBtn]スナップショットにファイルは存在しません",
"log.showSnapshot.start": "[showSnapshotBtn]スナップショット内のパス一覧を取得しています...",
"log.showFileContent.start": "[showFileContentBtn]ファイル内容を表示します: {path}",
"log.showFileContent.content": "[showFileContentBtn]{path} =>\n{content}",
"log.showConflictContent.start": "[showConflictContentBtn]競合内容を表示します: {path}",
"log.showConflictContent.content": "[showConflictContentBtn]{path} =>\n{content}",
"log.switchBranch.pulled": "[switchBranch]ブランチ切替 pull が完了しました: {branch}",
"log.switchBranch.start": "[switchBranch]ブランチを {branch} に切り替えます...",
"log.vfs.closed": "[{prefix}]VirtualFS を閉じました",
"log.vfs.closing": "[{prefix}]現在の VirtualFS を閉じます...",
"log.vfs.created": "[{prefix}]VirtualFS を作成し {displayName} を接続しました ({suffixLabel}={val})",
"log.vfs.createdShort": "VirtualFS 作成",
"log.vfs.initDone": "VirtualFS.init() 実行済み ({displayName})",
"log.vfs.initRunning": "[{prefix}]VirtualFS.init() 実行 ({displayName})",
"nextCommitsPage.label": "次のコミットページ",
"prompt.addLocalFile.content": "ファイル内容を入力してください",
"prompt.addLocalFile.name": "作成するファイル名を入力してください（例: examples/new.txt）",
"prompt.createBranch.fromRef": "基点となる SHA または ref を入力してください（空欄で既定）",
"prompt.createBranch.name": "作成するブランチ名を入力してください",
"prompt.deleteAndPush.path": "削除するファイルのパスを入力してください（例: examples/file.txt）",
"prompt.editAndPush.newContent": "新しいファイル内容を入力してください",
"prompt.editAndPush.path": "編集するファイルのパスを入力してください（例: examples/file.txt）",
"prompt.indexedDbName": "IndexedDB の DB 名を入力してください（空欄でデフォルト）",
"prompt.inmemoryRootName": "InMemory のルート名を入力してください（空欄でデフォルト）",
"prompt.opfsRootName": "OPFS のルート名を入力してください（空欄でデフォルト）",
"prompt.rename.from": "変更元のファイルパスを入力してください（例: examples/old.txt）",
"prompt.rename.to": "新しいファイル名を入力してください（例: examples/new.txt）",
"prompt.resolveConflict": "競合を解消するファイル名を入力してください（例: examples/new.txt）",
"prompt.revertChange": "元に戻すファイルパスを入力してください（例: examples/new.txt）",
"prompt.showFileContent.path": "表示するファイルパスを入力してください（例: examples/new.txt）",
"prompt.showConflictContent.path": "競合内容を表示するファイルパスを入力してください（例: examples/new.txt）",
"prompt.showSnapshot.dir": "表示対象のディレクトリを入力してください（空欄でルート）",
"prompt.switchBranch": "切替先のブランチ名を入力してください",
"results.clear": "クリア",
"results.clearTrace": "クリア",
"results.title": "結果",
"storage.add": "を追加",
"storage.close": "を閉じる",
"storage.delete": "を削除",
"storage.indexeddb": "IndexedDB",
"storage.inmemory": "InMemory",
"storage.opfs": "OPFS",
"storage.refresh": " の availableRoots を更新",
"storage.title": "ストレージ: 利用可能なルート",
"switchBranch.label": "ブランチを切り替え",
"actions.listCommits": "コミットを取得",
"actions.nextCommitsPage": "次のコミットページ",
"actions.listBranches": "ブランチを取得",
"actions.createBranch": "branch作成",
"actions.switchBranch": "ブランチを切り替え",
"trace.awaitVfsInit": "await currentVfs.init()",
"trace.backendInstanceCreate": "//[{namespace}]バックエンドインスタンスを作成: {displayName}",
"trace.constBackend": "const backend = new {displayName}(\"{namespace}\",{val})",
"trace.empty": " ",
"trace.indexedDbRootsCall": "[indexedDbRoots]availableRoots を呼び出します...",
"trace.indexedDbRootsJson": "[indexedDbRoots]availableRoots: {json}",
"trace.inMemoryRootsCall": "[inMemoryRoots]availableRoots を呼び出します...",
"trace.inMemoryRootsJson": "[inMemoryRoots]availableRoots: {json}",
"trace.loggerFmtError": "[logger]フォーマットエラー: {err}",
"trace.loggerFmtStringConvFailed": "[logger]文字列変換に失敗: {err}",
"trace.newVfs": "const currentVfs = new VirtualFS({ backend, logger })",
"trace.opfsRootsCall": "[opfsRoots]availableRoots を呼び出します...",
"trace.opfsRootsJson": "[opfsRoots]availableRoots: {json}",
"trace.raw": "{msg}",
"trace.vfsDebug": "[vfs]DEBUG: {msg}",
"trace.vfsError": "[vfs]ERROR: {msg}",
"trace.vfsInfo": "[vfs]INFO: {msg}",
"trace.vfsWarn": "[vfs]WARN: {msg}",
"trace.setListContents.domError": "[setListContents] DOM エラー: {err}",
"trace.clearOutput.error": "[clearOutputBtn] 出力クリアでエラー: {err}",
"trace.getCurrentAdapter.error": "[getCurrentAdapter] エラー: {err}",
"trace.vfs.closeCall": "await currentVfs.close() を呼び出します",
"trace.vfs.disposeCall": "await currentVfs.dispose() を呼び出します",
"trace.connectBtn.createDefaultInMemoryFailed": "[connectBtn] デフォルト InMemory VirtualFS の作成に失敗しました: {err}",
"trace.adapter.setGitHubAdapter": "await currentVfs.setAdapter('github', url, branch, token) => opts: {opts}",
"trace.adapter.setGitLabAdapter": "await currentVfs.setAdapter('gitlab', url, branch, token) => opts: {opts}",
"trace.connect.exceptionJson": "connect 例外: {json}",
"trace.switchBranch.pullCall": "const res = await currentVfs.pull({ ref: '{target}' }) を呼び出します",
"trace.switchBranch.pullResult": "pull の結果 => {res}",
"trace.switchBranch.setBranchInputFailed": "[switchBranch] branchInput の設定に失敗しました: {err}",
"trace.opfsRoots.availableRootsError": "[opfsRoots] availableRoots 実行時エラー: {err}",
"trace.indexedDbRoots.availableRootsError": "[indexedDbRoots] availableRoots 実行時エラー: {err}",
"trace.populateAdapterMetadata.unexpectedError": "[populateAdapterMetadata] 予期しないエラー: {err}",
"trace.connectVfs.pendingAdapterError": "[connectVfs] 保留中アダプタの設定に失敗しました: {err}",
"trace.connectVfs.pendingAdapterOuterError": "[connectVfs] 保留中アダプタ処理の外部エラー: {err}",
"trace.fetchRemote.comment": "// リポジトリへアクセスしています",
"trace.fetchRemote.pullCall": "const res = await currentVfs.pull({ ref: '{branch}' }) を呼び出します",
"trace.fetchRemote.pullResult": "pull の結果 => {res}",
"trace.resolveConflict.comment": "// コンフリクト解決処理",
"trace.resolveConflict.call": "const ok = await currentVfs.resolveConflict({path}) を呼び出します",
"trace.resolveConflict.result": "解決結果 => {ok}",
"trace.revertChange.comment": "// 変更を元に戻します",
"trace.revertChange.deleteBlobCall": "await backend.deleteBlob({path}, 'workspace') を呼び出します",
"trace.revertChange.vfsInitCall": "await currentVfs.init() を呼び出します",
"trace.addLocalFile.comment": "// ローカルファイルの追加/書き込み",
"trace.addLocalFile.writeCall": "await currentVfs.writeFile('{path}', '{content}') を呼び出します",
"trace.localChanges.comment": "// ローカルのチェンジセットを取得します",
"trace.localChanges.getChangeSetCall": "const changes = await currentVfs.getChangeSet() を呼び出します",
"trace.localChanges.result": "changes => {res}",
"trace.pushLocal.comment": "// ローカルの変更をリモートへ push します",
"trace.pushLocal.getChangeSetCall": "const changes = await currentVfs.getChangeSet() を呼び出します",
"trace.pushLocal.changesResult": "changes => {res}",
"trace.pushLocal.getIndexCall": "const idx = await currentVfs.getIndex() を呼び出します",
"trace.pushLocal.indexResult": "idx => {res}",
"trace.pushLocal.pushCall": "const res = await currentVfs.push({input}) を呼び出します",
"trace.pushLocal.pushResult": "push の結果 => {res}",
"trace.editAndPush.comment": "// 既存ファイルを読み取っています",
"trace.editAndPush.readCall": "const existing = await currentVfs.readFile('{path}') を呼び出します",
"trace.editAndPush.existingResult": "existing => {res}",
"trace.editAndPush.writeCall": "await currentVfs.writeFile('{path}', '{content}') を呼び出します",
"trace.deleteAndPush.comment": "// ファイルを削除します",
"trace.deleteAndPush.unlinkCall": "await currentVfs.unlink('{path}') を呼び出します",
"trace.rename.comment": "// ファイル名を変更します",
"trace.rename.renameCall": "await currentVfs.renameFile({from}, {to}) を呼び出します",
"trace.showSnapshot.comment": "// スナップショットのパス一覧を取得します",
"trace.showSnapshot.readdirCall": "const paths = await currentVfs.readdir('{dir}') を呼び出します",
"trace.showSnapshot.pathsResult": "paths => {res}",
"trace.showFileContent.readCall": "const content = await currentVfs.readFile('{path}') を呼び出します",
"trace.showConflictContent.readCall": "const content = await currentVfs.readConflict('{path}') を呼び出します",
"trace.remoteChanges.comment": "// リモートの変更を確認します",
"trace.remoteChanges.call": "const res = await currentVfs.getRemoteDiffs() を呼び出します",
"trace.remoteChanges.result": "res => {res}",
"trace.listCommits.comment": "// VirtualFS.listCommits を呼び出します",
"trace.listCommits.call": "const page = await currentVfs.listCommits({query}) を呼び出します",
"trace.listCommits.result": "listCommits => {res}",
"trace.nextCommitsPage.comment": "// 次ページのコミットを取得します",
"trace.nextCommitsPage.result": "listCommits(next) => {res}",
"trace.listBranches.comment": "// ブランチ一覧を取得します",
"trace.listBranches.call": "const page = await currentVfs.listBranches({query}) を呼び出します",
"trace.listBranches.result": "listBranches => {res}",
"trace.listBranches.itemError": "[listBranches] アイテムごとのエラー: {err}",
"trace.createBranch.comment": "// 新しいブランチを作成します",
"trace.createBranch.call": "const res = await currentVfs.createBranch({input}) を呼び出します",
"trace.createBranch.result": "createBranch => {res}",
"trace.listFilesRaw.comment": "// listFilesRaw() を実行します",
"trace.listFilesRaw.call": "const files = await currentVfs.listFilesRaw() を呼び出します",
"trace.listFilesRaw.result": "files => {res}",
"trace.listFilesRaw.backendCall": "const files = await backend.listFilesRaw() を呼び出します",
"trace.listFilesRaw.backendResult": "files => {res}",
"ui.description": "GitHub/GitLab のリポジトリ情報と Personal Access Token を入力してライブラリを試せます。",
"ui.empty": "（なし）",
"ui.title": "browser-git-ops - サンプル UI"
}